import { useCallback, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { useListenEventBus } from '../libs/custom-hooks';
import { globalVars } from '../libs/global-vars';

const AK_URL_SYNC_ENVS = ['DEV', 'STG'];

export enum HistoryManagerEvent {
  PUSH_HISTORY = 'PUSH_HISTORY',
  REPLACE_HISTORY = 'REPLACE_HISTORY',
  GO_BACK = 'GO_BACK',
  CHANGE_START = 'CHANGE_START',
}

// react 외부에서 히스토리 변경 요청용
const HistoryManager = withRouter(function ({ history }) {
  const onRequestPushHistory = useCallback(
    (url, state) => {
      history.push(url, state);
    },
    [history],
  );
  const onRequestReplaceHistory = useCallback(
    (url, state) => {
      history.replace(url, state);
    },
    [history],
  );
  const onRequestGoBack = useCallback(() => {
    history.goBack();
  }, [history]);

  useListenEventBus(HistoryManagerEvent.PUSH_HISTORY, onRequestPushHistory);
  useListenEventBus(HistoryManagerEvent.REPLACE_HISTORY, onRequestReplaceHistory);
  useListenEventBus(HistoryManagerEvent.GO_BACK, onRequestGoBack);

  // 라우팅으로 쿼리스트링이 날아가도 새로고침 시 접근키를 잃지 않도록 URL에 ak를 유지한다
  useEffect(() => {
    if (!AK_URL_SYNC_ENVS.includes(process.env.REACT_APP_BUILD_ENV || '')) return;

    const syncAccessKeyToUrl = () => {
      const accessKey = globalVars.accessKey;
      if (!accessKey) return;

      const params = new URLSearchParams(window.location.search);
      if (params.get('ak') === accessKey) return;

      params.set('ak', accessKey);
      window.history.replaceState(
        window.history.state,
        '',
        `${window.location.pathname}?${params}${window.location.hash}`,
      );
    };

    syncAccessKeyToUrl();
    return history.listen(syncAccessKeyToUrl);
  }, [history]);

  return null;
});

export { HistoryManager };
